module.exports = __webpack_public_path__ + "images/embed/rolodex_spinner.gif";